
export const RESEARCH_FETCH   = 'RESEARCH_FETCH'; 
export const RESEARCH_UPDATE  = 'RESEARCH_UPDATE'; 
export const RESEARCH_SEARCH  = 'RESEARCH_SEARCH'; //append the search
export const RESEARCH_FAIL    = 'RESEARCH_FAIL'; 